import { Quiz, QuizResultsType } from "../models/Quiz";

export const initialQuizData: Quiz = {
  quizSlides: [
    {
      questionId: 0,
      questionText: "When your to-do list feels endless, you usually:",
      answers: [
        {
          answerId: 0,
          answerText: "Try to squeeze in a little of everything so nothing is left undone.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 1,
          answerText: "Focus on what excites you most, even if other things slip.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 2,
          answerText: "Say yes to helping others first, then tackle your own list.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 3,
          answerText: "Push through with sheer willpower, crossing things off fast.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        }
      ]
    },
    {
      questionId: 1,
      questionText: "What stresses you out the most in daily life?",
      answers: [
        {
          answerId: 0,
          answerText: "Never feeling like there’s enough time for family and work.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 1,
          answerText: "Feeling guilty when you say no to someone.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 2,
          answerText: "Having a hundred ideas but struggling to execute them all.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 3,
          answerText: "Starting strong but losing steam before you finish.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        }
      ]
    },
    {
      questionId: 2,
      questionText: "When you think about your goals, you tend to:",
      answers: [
        {
          answerId: 0,
          answerText: "Have a clear vision but get stuck in the planning stage.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 1,
          answerText: "Charge forward quickly, but sometimes burn out along the way.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        },
        {
          answerId: 2,
          answerText: "Prioritize what everyone else needs before your own dreams.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 3,
          answerText: "Try to create balance, even if it means you sacrifice rest.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        }
      ]
    },
    {
      questionId: 3,
      questionText: "If a friend asked you to describe yourself in one word, it would be:",
      answers: [
        {
          answerId: 0,
          answerText: "Reliable",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 1,
          answerText: "Creative",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 2,
          answerText: "Energetic",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        },
        {
          answerId: 3,
          answerText: "Caring",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        }
      ]
    },
    {
      questionId: 4,
      questionText: "At the end of a busy week, you often feel:",
      answers: [
        {
          answerId: 0,
          answerText: "Excited about new ideas you haven’t had time to start.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 1,
          answerText: "Drained from overcommitting to others.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 2,
          answerText: "Torn in too many directions.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 3,
          answerText: "Frustrated that your energy fizzled out mid-week.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        }
      ]
    },
    {
      questionId: 5,
      questionText: "When making a tough decision, you usually:",
      answers: [
        {
          answerId: 0,
          answerText: "Think about how it will affect others first.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 1,
          answerText: "Ask yourself which option will give you more balance.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 2,
          answerText: "Follow your excitement, even if it’s a leap.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 3,
          answerText: "Choose the option that gets you moving fastest.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        }
      ]
    },
    {
      questionId: 6,
      questionText: "What would you most like more of in your life right now?",
      answers: [
        {
          answerId: 0,
          answerText: "Confidence to set clear boundaries without guilt.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 1,
          answerText: "Structure so I can balance all the moving parts.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 2,
          answerText: "Follow-through so I can finish what I start.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        },
        {
          answerId: 3,
          answerText: "Clarity to turn my big ideas into reality.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        }
      ]
    },
    {
      questionId: 7,
      questionText: "Your superpower as a mom is:",
      answers: [
        {
          answerId: 0,
          answerText: "Always being there when others need you.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 1,
          answerText: "Dreaming of possibilities for your family’s future.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 2,
          answerText: "Keeping the wheels turning no matter what.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        },
        {
          answerId: 3,
          answerText: "Managing multiple roles with grace (most of the time).",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        }
      ]
    },
    {
      questionId: 8,
      questionText: "When life feels full, what’s your natural response?",
      answers: [
        {
          answerId: 0,
          answerText: "I step back and rework my schedule or priorities — I need things to feel steady and fair.",
          selected: false,
          answerType: QuizResultsType.BALANCE_BUILDER
        },
        {
          answerId: 1,
          answerText: "I pause, say no where I need to, and protect my space and energy.",
          selected: false,
          answerType: QuizResultsType.BOUNDARY_SETTER
        },
        {
          answerId: 2,
          answerText: "I zoom out, look at the bigger picture, and start dreaming of a new direction.",
          selected: false,
          answerType: QuizResultsType.VISIONARY_LEADER
        },
        {
          answerId: 3,
          answerText: "I get moving — taking action helps me feel back in control and clear again.",
          selected: false,
          answerType: QuizResultsType.MOMENTUM_MAKER
        }
      ]
    }
  ]
};